import {
  lucideActivity,
  lucideArrowDown,
  lucideArrowDownUp,
  lucideArrowLeftRight,
  lucideArrowRight,
  lucideArrowUp,
  lucideArrowUpDown,
  lucideBan,
  lucideBanknote,
  lucideBomb,
  lucideBookOpen,
  lucideBriefcaseBusiness,
  lucideCalendar,
  lucideCalendarClock,
  lucideChartGantt,
  lucideChartLine,
  lucideCheck,
  lucideCheckCheck,
  lucideChevronDown,
  lucideChevronLeft,
  lucideChevronRight,
  lucideChevronsUpDown,
  lucideChevronUp,
  lucideCircleAlert,
  lucideCircleCheck,
  lucideClock,
  lucideCloudDownload,
  lucideCloudUpload,
  lucideCode,
  lucideCoins,
  lucideColumns3,
  lucideCommand,
  lucideCopy,
  lucideCreditCard,
  lucideCurrency,
  lucideDot,
  lucideDownload,
  lucideExpand,
  lucideExternalLink,
  lucideEye,
  lucideEyeOff,
  lucideFileWarning,
  lucideFilter,
  lucideFlag,
  lucideFolderOpen,
  lucideFullscreen,
  lucideGauge,
  lucideGavel,
  lucideHand,
  lucideHash,
  lucideInfinity,
  lucideInfo,
  lucideKey,
  lucideLandmark,
  lucideLetterText,
  lucideListFilter,
  lucideListFilterPlus,
  lucideListX,
  lucideLoaderCircle,
  lucideLogOut,
  lucideMailCheck,
  lucideMap,
  lucideMapPin,
  lucideMapPinned,
  lucideMinimize2,
  lucideMoon,
  lucideNewspaper,
  lucidePackage,
  lucidePackageOpen,
  lucidePackageSearch,
  lucidePen,
  lucidePencil,
  lucidePenTool,
  lucidePill,
  lucidePlus,
  lucideReceipt,
  lucideRotateCcw,
  lucideSearch,
  lucideSearchX,
  lucideSettings,
  lucideSettings2,
  lucideShield,
  lucideShieldAlert,
  lucideShieldBan,
  lucideShieldCheck,
  lucideShieldEllipsis,
  lucideShip,
  lucideSkull,
  lucideSun,
  lucideSwords,
  lucideTextSearch,
  lucideTrash2,
  lucideTrees,
  lucideTrendingDown,
  lucideTrendingUp,
  lucideTrendingUpDown,
  lucideUser,
  lucideUserCheck,
  lucideUserRound,
  lucideUserRoundCheck,
  lucideUserRoundX,
  lucideUsers,
  lucideWallet,
  lucideWeight,
  lucideX
} from '@ng-icons/lucide';

// INFO: we use ng-icons for the whole app, any icon used needs to be imported here or they can be provided directly in the component where they are used. This icons const is imported into app.config.ts
// https://ng-icons.github.io/ng-icons/#/browse-icons
export const icons = {
  lucideMailCheck,
  lucideShieldCheck,
  lucideChevronRight,
  lucideChevronDown,
  lucideChevronLeft,
  lucideSun,
  lucideMoon,
  lucideSearch,
  lucideSettings,
  lucideUserRound,
  lucideCommand,
  lucidePlus,
  lucideX,
  lucideCreditCard,
  lucideUsers,
  lucideUserRoundCheck,
  lucideUserRoundX,
  lucideCalendar,
  lucideCalendarClock,
  lucideChartGantt,
  lucideSettings2,
  lucideColumns3,
  lucideArrowDownUp,
  lucideChevronUp,
  lucideChevronsUpDown,
  lucideLogOut,
  lucideExpand,
  lucideListX,
  lucideMinimize2,
  lucideLoaderCircle,
  lucideCloudDownload,
  lucideCloudUpload,
  lucideShieldAlert,
  lucideEyeOff,
  lucideEye,
  lucideCheckCheck,
  lucideBookOpen,
  lucidePackageOpen,
  lucidePen,
  lucideArrowRight,
  lucideDownload,
  lucideFullscreen,
  lucideCircleAlert,
  lucideFlag,
  lucideCircleCheck,
  lucideFolderOpen,
  lucideClock,
  lucideInfinity,
  lucidePencil,
  lucideTrash2,
  lucideCheck,
  lucideInfo,
  lucideTextSearch,
  lucideSearchX,
  lucideArrowUp,
  lucideArrowDown,
  lucideArrowUpDown,
  lucideFilter,
  lucideDot,
  lucideExternalLink,
  lucideTrendingDown,
  lucideTrendingUpDown,
  lucideTrendingUp,
  lucideGauge,
  lucideNewspaper,
  lucideRotateCcw,
  lucideShield,
  lucideGavel,
  lucideHand,
  lucideBanknote,
  lucideFileWarning,
  lucideBomb,
  lucideBan,
  lucidePill,
  lucidePenTool,
  lucideKey,
  lucideSkull,
  lucideSwords,
  lucideChartLine,
  lucideTrees,
  lucideReceipt,
  lucidePackage,
  lucideCopy,
  lucideCoins,
  lucidePackageSearch,
  lucideShip,
  lucideCode,
  lucideListFilter,
  lucideListFilterPlus,
  lucideHash,
  lucideUser,
  lucideMap,
  lucideShieldEllipsis,
  lucideLandmark,
  lucideUserCheck,
  lucideActivity,
  lucideBriefcaseBusiness,
  lucideArrowLeftRight,
  lucideShieldBan,
  lucideWallet,
  lucideCurrency,
  lucideMapPin,
  lucideMapPinned,
  lucideWeight,
  lucideLetterText
};
